import { CmObjectType } from '../cta/CmObjectType.js';
/**
 * Common Media Client Data Object Type
 *
 * @group CMCD
 *
 * @beta
 *
 * @enum
 */
export const CmcdObjectType = CmObjectType;
//# sourceMappingURL=CmcdObjectType.js.map